async function updateAlert(cart) {
    const warningElm = document.getElementById("group-product-warning")
    if (cart.items.length === 0) {
        if (warningElm) {
            warningElm.classList.add('hidden')
        }
        return
    }

    const tagToSearch = 'グループ商品';
    const getProductGroupTag = (product) => product.tags.find((tag) => tag.startsWith(tagToSearch))

    let allGroupProducts = await fetch('/products.json')
        .then((response) => response.json())
        .then((productsResponse) => {
            const productsWithTags = productsResponse.products.filter((product) => {
                return product.tags.find((tag) => tag.startsWith(tagToSearch));
            });
            return productsWithTags
        });

    allGroupProducts = allGroupProducts.sort((productA, productB) => {
        const groupTagA = getProductGroupTag(productA)
        const groupTagB = getProductGroupTag(productB)
        return groupTagA.localeCompare(groupTagB)
    })

    const getCartGroupProducts = () => {
        const items = cart.items
        return allGroupProducts.filter((groupProduct) =>
            items.find((item) => item.product_id === groupProduct.id)
        )
    };

    const cartGroupProducts = getCartGroupProducts()
    const remainingGroupProducts = []

    allGroupProducts.forEach((groupProduct) => {
        const groupProductTag = getProductGroupTag(groupProduct)
        cartGroupProducts.forEach(cartProduct => {
            const cartProductTag = getProductGroupTag(cartProduct)
            if (cartProductTag === groupProductTag && !cartGroupProducts.find(p => p.id === groupProduct.id) && !remainingGroupProducts.find(p => p.id === groupProduct.id)) {
                remainingGroupProducts.push(groupProduct)
            }
        })
    })

    const availableElm = document.getElementById("group-product-available")
    const remainingElm = document.getElementById("group-product-remaining")
    const checkoutButton = document.getElementById('checkout')
    const additionalCheckoutButtons = document.getElementsByClassName('additional-checkout-buttons')[0]

    if (remainingGroupProducts.length > 0) {
        availableElm.innerHTML = ''
        remainingElm.innerHTML = ''
        checkoutButton.setAttribute('disabled', true)
        for (const availableProduct of cartGroupProducts) {
            const node = document.createElement("div")
            node.innerHTML = `・${availableProduct.title}`
            node.className = "group-product-warning__available-item"
            availableElm.appendChild(node)
        }
        for (const remainingProduct of remainingGroupProducts) {
            const node = document.createElement("a")
            node.href = `/products/${remainingProduct.handle}`
            node.innerHTML = `・${remainingProduct.title}`
            node.className = "group-product-warning__remaining-item"
            remainingElm.appendChild(node)
        }
        warningElm.classList.remove('hidden')
        additionalCheckoutButtons.classList.add('hidden')
        checkoutButton.classList.add('cart__checkout-button--disabled')
    } else {
        warningElm.classList.add('hidden')
        checkoutButton.removeAttribute('disabled')
        additionalCheckoutButtons.classList.remove('hidden')
        checkoutButton.classList.remove('cart__checkout-button--disabled')
    }
}

(async () => {
    await fetch('/cart.js')
        .then((response) => response.json())
        .then((cartResponse) => {
            updateAlert(cartResponse)
        });
})()
window.addEventListener('SCE:change', (event) => {
    updateAlert(event.detail)
})

